import { Box, Button, Stack, Typography } from "@mui/material";
import { MRT_Row, MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext } from "./ColumnHelpers";
import { columnDisplayNames } from "../../../admin/ImportSettings";
import { getValidationErrorKey } from "../../../../utilities/jobValidation";
import { Close, Upload } from "@mui/icons-material";

export function column_FieldNotes(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	const displayName = columnDisplayNames["fieldNotes"];
	const validationKey = "fieldNotes";

	return {
		id: validationKey,
		header: displayName,
		accessorFn: (row) => row.files?.fieldNotes,
		enableEditing: false,
		minSize: 300,
		Cell: ({ row }: { row: MRT_Row<Job> }) => {
			const jobId = row.original.id;
			const files = row.original.files.fieldNotes || [];
			const errorKey = getValidationErrorKey(validationKey, jobId);
			const hasError = !!context.validationErrors[errorKey];

			return (
				<Stack spacing={1} sx={{ width: "100%", padding: 1 }}>
					{files.map((file, index) => (
						<Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
							<Typography variant="body2" sx={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>
								{file.name}
							</Typography>
							<Button
								size="small"
								startIcon={<Close />}
								onClick={() => {
									const newJobs = [...context.jobs];
									const newJob = newJobs.find((job) => job.id === row.original.id);
									if (!newJob) return;

									// Remove the file at the specified index
									const newFiles = [...(newJob.files.fieldNotes || [])];
									newFiles.splice(index, 1);
									newJob.files.fieldNotes = newFiles;

									context.setJobs(newJobs);
									context.validateJobs(newJobs, { updateState: true, clearPrevious: false });
								}}
							>
								Remove
							</Button>
						</Box>
					))}
					<Box>
						<input
							type="file"
							multiple
							id={`fieldNotes-upload-${jobId}`}
							style={{ display: "none" }}
							onChange={(e) => {
								const selectedFiles = e.target.files;
								if (!selectedFiles || selectedFiles.length === 0) return;

								const newJobs = [...context.jobs];
								const newJob = newJobs.find((job) => job.id === row.original.id);
								if (!newJob) return;

								// Add new files to existing files
								const existingFiles = newJob.files.fieldNotes || [];
								const newFileArray = Array.from(selectedFiles);
								newJob.files.fieldNotes = [...existingFiles, ...newFileArray];

								context.setJobs(newJobs);
								context.validateJobs(newJobs, { updateState: true, clearPrevious: false });

								// Clear the input so the same file can be selected again
								e.target.value = "";
							}}
						/>
						<Button
							size="small"
							variant="outlined"
							startIcon={<Upload />}
							onClick={() => {
								const input = document.getElementById(`fieldNotes-upload-${jobId}`) as HTMLInputElement;
								input?.click();
							}}
							sx={{ width: "100%" }}
						>
							Upload Files
						</Button>
						{hasError && (
							<Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
								{context.validationErrors[errorKey]}
							</Typography>
						)}
					</Box>
				</Stack>
			);
		},
	};
}
